import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { HERO_IMAGE } from "@/lib/studio";
import { NextOpenDay } from "@/components/landing/NextOpenDay";

export const Hero = () => (
  <section className="grain relative overflow-hidden" data-testid="hero-section">
    <img src={HERO_IMAGE} alt="Riot Factory studio" className="absolute inset-0 h-full w-full object-cover opacity-30" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0C] via-[#0A0A0C]/85 to-[#0A0A0C]/40" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-6 py-24 md:px-12 lg:grid-cols-12 lg:py-36">
      <div className="lg:col-span-7">
        <p className="eyebrow rise">Content creation studio · Weekdays only</p>
        <h1 className="rise d1 mt-6 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
          Make noise.<br />
          <span className="text-[#FF3333]">Book the Factory.</span>
        </h1>
        <p className="rise d2 mt-8 max-w-xl text-base text-zinc-300 md:text-lg">
          Reserve Riot Factory for a morning, afternoon or evening session, Monday to Friday. Pick the Main Stage, Podcast or ASMR Room and get creating.
        </p>
        <div className="rise d3 mt-10 flex flex-wrap gap-4">
          <Link to="/book" className="btn-riot" data-testid="hero-book-btn">
            Book a session <ArrowRight className="h-4 w-4" />
          </Link>
          <a href="#spaces" className="btn-ghost-riot" data-testid="hero-spaces-btn">Explore spaces</a>
        </div>
      </div>
      <div className="rise d4 lg:col-span-5 lg:pt-10">
        <NextOpenDay />
      </div>
    </div>
  </section>
);
